export default __webpack_public_path__ + "static/media/IMG_1968.60d9790c.JPG";